import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { SharedApiService, ApiType } from '../../../../../libs/shared/src/lib/services/api.service';

export interface ProfileSettings {
  categories: any[];
  employmentTypes: any[];
  userStatuses: string[];
  positions?: any[]; // All positions with jobCategoryId for filtering
  positionsOfActiveCategories?: any[]; // Positions for user's currently active categories
}

export interface ProfileSettingsResponse {
  status: number;
  message?: string;
  body?: ProfileSettings;
}

export interface UpdateStatusRequest {
  status: string;
}

export interface UpdateStatusResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProfileSettingsService {
  constructor(private sharedApiService: SharedApiService) {}

  /**
   * Fetches profile settings including user status options
   * @returns Observable with profile settings data
   */
  getProfileSettings(): Observable<ProfileSettings> {
    return this.sharedApiService
      .get<ProfileSettings>('api/get-profile-settings', undefined, { apiType: ApiType.OPEN, jobsRequest: true })
      .pipe(
        map((response: any) => {
          // Handle response structure
          if (response && response.body) {
            return response.body as ProfileSettings;
          }
          return response as ProfileSettings;
        }),
        catchError((error) => {
          console.error('Error fetching profile settings:', error);
          return throwError(() => error);
        })
      );
  }

  /**
   * Updates the user's status
   * @param status The new status (Available, Unavailable, Hired)
   * @returns Observable with the update response
   */
  updateUserStatus(status: string): Observable<UpdateStatusResponse> {
    const payload: UpdateStatusRequest = { status };

    return this.sharedApiService
      .put<UpdateStatusResponse>('api/user/update-status', payload, undefined, { apiType: ApiType.OPEN, jobsRequest: true })
      .pipe(
        map((response: any) => {
          // Handle response structure
          if (response && response.message) {
            return response as UpdateStatusResponse;
          }
          return { message: 'Status updated successfully' };
        }),
        catchError((error) => {
          console.error('Error updating user status:', error);
          return throwError(() => error);
        })
      );
  }
}
